import React, {Component} from 'react';
import "./News.scss"
import Footer from "../../components/Footer/Footer";
import Navs from "../../components/Navs/Navs";
import ComTitle from "../../components/ComTitle/ComTitle";
import {titleObj} from "../../config/configPublic";
import Pages from "../../components/Pages/Pages";
import {NavLink} from "react-router-dom";

class News extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: {
                list: [" 行业新闻", "公司新闻", "物流资讯"],
                index: 0,
            },
            page: {
                count: 50,
                index: 1,
                size: 9,
            },
            dataList: [],
            picUrl: ""
        }
    }

    componentDidMount() {
        this.getNewsList();
    }

    getNewsList() {
        let {tabs, page} = this.state;
        let data = {
            type: tabs.index + 1,
            pageNum: page.index,
            pageSize: page.size,
        }
        this.$axios.apiList.getNewsList(data)
            .then(res => {
                page.count = res.data.pageInfo.total;
                this.setState({
                    dataList: res.data.pageInfo.list,
                    picUrl: res.data.picUrl
                })
            })
            .catch(error => {

            })
    }

    tabsClick(index) {
        let {tabs, page} = this.state;
        tabs.index = index;
        page.index = 1;
        this.getNewsList();
    }

    callbackPage(pageIndex) {
        let {page} = this.state;
        page.index = pageIndex;
        this.getNewsList();
    }

    render() {
        let {tabs, page, dataList, picUrl} = this.state;
        let obj;
        if (dataList.length > 1) {
            obj = dataList.splice(0, 1)[0];
        }
        return (
            <div className="news">
                <div className="navs">
                    <Navs fullPageIndex={6}/>
                </div>
                <div className="picUrl">
                    <img src={picUrl} alt=""/>
                </div>
                <ComTitle {...titleObj.news}/>
                <div className="content">
                    <div className="content-tabs">
                        {
                            tabs.list.map((item, index) => {
                                return (
                                    <div className={`item${index === tabs.index ? " in" : ""}`}
                                         onClick={this.tabsClick.bind(this, index)}
                                         key={index}>
                                        {item}
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="content-list">
                        {
                            obj &&
                            <NavLink to={`/newsDetails/${obj.id}`} className="list-top">
                                <div className="left">
                                    <div className="title">
                                        {obj.title}
                                    </div>
                                    <div className="text">
                                        {obj.content}
                                    </div>
                                    <div className="time">
                                        <div>{obj.createTime.substring(obj.createTime.length - 5, obj.createTime.length)}</div>
                                        <div>{obj.createTime.substring(0, 4)}</div>
                                    </div>
                                </div>
                                <div className="right">
                                    <img src={obj.imageUrl} alt=""/>
                                </div>
                            </NavLink>
                        }
                        <div className="list">
                            {
                                dataList.map((item, index) => {
                                    return (
                                        <NavLink to={`/newsDetails/${item.id}`} className="item" key={index}>
                                            <div className="icon">
                                                <img src={item.imageUrl} alt=""/>
                                            </div>
                                            <div className="center">
                                                <div className="text">
                                                    <div>
                                                        {item.title}
                                                    </div>
                                                    <div>
                                                        {item.content}
                                                    </div>
                                                </div>
                                                <div className="time">
                                                    <div>{item.createTime.substring(item.createTime.length - 5, item.createTime.length)}</div>
                                                    <div>{item.createTime.substring(0, 4)}</div>
                                                </div>
                                                <div className="right">
                                                    <i className="iconfont icon-xinwenzhongxin-dianji"></i>
                                                </div>
                                            </div>
                                        </NavLink>
                                    )
                                })
                            }
                        </div>
                    </div>
                    {
                        page.count !== 0 && <Pages page={page} callback={this.callbackPage.bind(this)}></Pages>
                    }
                </div>
                <Footer></Footer>
            </div>
        );
    }
}

export default News;
